import * as React from "react";
import { useState,useEffect  } from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  IconButton, Stack, TextField
} from "@mui/material";
// import gregorian from "react-date-object/calendars/gregorian";
import { Messages } from "../data/Messages";
import { useSnackbar } from "notistack";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Popover from "@mui/material/Popover";
import { Calendar } from "react-multi-date-picker";
import { DataGrid } from '@mui/x-data-grid';
// import DatePicker, { DateObject } from 'react-multi-date-picker';
import { apiMain } from "../../App";
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
// import { setResponsiveMode } from "office-ui-fabric-react";
export default function ResturantTable(props) {
  const columns = [
    // { field: 'Id', headerName: 'ID', width: 90 },
    { field: 'Reserv_Id', headerName: 'Id', width: 1 , hideable: true},
    {
      field: 'Room_Number',
      headerName: 'Room Number',
      width: 50,
      editable: true,
    },
    {
      field: 'Full_Name',
      headerName: 'Full name',
      width: 90,
      editable: true,
    },
  ]
useEffect(() => {
  if (props.permission.length>0)
  {

   setAddflag(props.permission[8].Per_Add)
   setEditFlag(props.permission[8].Per_Edit)
   setDelFlag(props.permission[8].Per_Del)
  }

getDataRoom();
}, [])
const [data, setData] = useState();
  const [rows, setRows] = useState(props.data || []);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [editMode, setEditMode] = useState(false); // حالت ویرایش
  const [addoredit ,setAddOrEdit]=useState(false);
  const [Pass_No, setPass_No] = useState(0);
  const [Pass_FName, setPass_FName] = useState("");
    // const [Reserv_Id, setReserv_Id] = useState(0);
    	const [Id, setId] = useState(0);
    const [Resturant_Date, setResturant_Date] = useState("");
    const [Resturant_Desc, setResturant_Desc] = useState("");
    const [Resturant_Pay, setResturant_Pay] = useState(0); 
      const { enqueueSnackbar } = useSnackbar();
  const [dialogLoading, setDialogLoading] = useState(false);
  const [dialogError, setDialogError] = useState({});
  // مدیریت Popover تقویم
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeRowId, setActiveRowId] = useState(null);
  const [NewFlag,setNewFlag]=useState(true);
  const [Addflag,setAddflag]=useState(false);
  const [EditFlag,setEditFlag]=useState(false);
  const [DelFlag,setDelFlag]=useState(false);
  const [dataroom, setDataRoom] = useState();
  const getData = async ( ) => {

    let uparams = new URLSearchParams();
    uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));

      let res = await GetDataPromise(`${apiMain}/api/v1/restaurant/selectrestaurant?${uparams}`, true);

    let parsed = JSON.parse(res);

    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        let newData = parsed.data;
        
        setData(newData)
    
        setRows(newData.map(item => ({ ...item, id: item.Id })));

   
      //   if(newData.length !== 0)
      // {  setSelectedRowId(newData[0].Id)}
    }
 
}
  const getDataRoom = async ( ) => {

    // let uparams = new URLSearchParams();
    // uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));
  
      let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectcheckin`, true);
  
    let parsed = JSON.parse(res);
  
    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        let newData = parsed.data;
           setDataRoom(newData)
       
    }
  }
  const sendAdd = async (e) => {
  let formdata = new FormData;

  let errors = {};
 // setPass_Id(0);
  formdata.append("Reserv_Id",localStorage.getItem('Reserv_Id'));
  formdata.append("Id", Id);
  formdata.append("Resturant_Date", e[0].Resturant_Date);
  formdata.append("Resturant_Desc", e[0].Resturant_Desc);
  formdata.append("Resturant_Pay", e[0].Resturant_Pay);
  console.log("Reserv_Id", formdata.get('Reserv_Id'));
  console.log("Id", formdata.get('Id'));
  console.log("Resturant_Date", formdata.get('Resturant_Date'));
  console.log("Resturant_Desc", formdata.get('Resturant_Desc'));
  console.log("Resturant_Pay", formdata.get('Resturant_Pay'));
  let response;
  
       response = await PostDataPromise(apiMain + "/api/v1/restaurant/insert", formdata);
    let parsed = JSON.parse(response);
    console.log(parsed)
  setDialogLoading(false);
  if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
      // okay
      enqueueSnackbar(Messages.success, { variant: 'success' });

      // props.save()
  } else {
      if(parsed.data && typeof parsed.data.message === "string"){
          enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
      }
      setDialogError((parsed.data) ? parsed.data.message : {})
  }
//  setUpdateCount((prev) => prev + 1)
  getData();
 // cleardata();
}
    const sendUpdate = async (e) => {
      let formdata = new FormData;

      let errors = {};
     // setPass_Id(0);
      formdata.append("Reserv_Id",  localStorage.getItem('Reserv_Id'));
      formdata.append("Id", e[0].Id);
      // formdata.append("Resturant_Date", Resturant_Date);
      // formdata.append("Resturant_Desc", Resturant_Desc);
      // formdata.append("Resturant_Pay", Resturant_Pay);
      formdata.append("Resturant_Date", e[0].Resturant_Date);
      formdata.append("Resturant_Desc", e[0].Resturant_Desc);
      formdata.append("Resturant_Pay", e[0].Resturant_Pay);

      // console.log("Reserv_Id", formdata.get('reserv_id'));
      // console.log("Id", formdata.get('Id'));
      // console.log("Resturant_Date", formdata.get('Resturant_Date'));
      // console.log("Resturant_Desc", formdata.get('Resturant_Desc'));
      // console.log("Resturant_Pay", formdata.get('Resturant_Pay'));
      let response;
               response = await PostDataPromise(apiMain + "/api/v1/restaurant/update", formdata);
          let parsed = JSON.parse(response);
    
   
      setDialogLoading(false);
         if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
          // okay
          enqueueSnackbar(Messages.success, { variant: 'success' });

          // props.save()
      } else {
          if(parsed.data && typeof parsed.data.message === "string"){
              enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
          }
          setDialogError((parsed.data) ? parsed.data.message : {})
      }
 //     setUpdateCount((prev) => prev + 1)
      getData();
  //    cleardata();
  }
  const sendDelete = async (e) => {
     let formdata = new FormData;

    // let errors = {};
    formdata.append("Id", Id);

    let response;
    if(Id > 0){

         response = await PostDataPromise(apiMain + "/api/v1/restaurant/delete", formdata);

        //  let parsed = JSON.parse(response);

         
     } 
    }
  const   handleRowClick = (params) => {

    // props.allupdate(
    // params.row.id,
    setPass_FName(params.row.Full_Name)
    setPass_No(  params.row.Pass_No)

    localStorage.setItem('Reserv_Id', params.row.Reserv_Id)

getDataRoom();
    getData();

    //   params.row.Resturant_Pay,
  // )
     };
     
  // اضافه کردن ردیف جدید
  const handleAdd = () => {
    const newId = crypto.randomUUID();
    const newRow = { id: newId, Resturant_Date: null, Resturant_Desc: "", Resturant_Pay: 0 };

    setRows([newRow, ...rows]);
    setSelectedRowId(newId);
    setEditMode(true);
    setAddOrEdit(true)
  };

  // فعال کردن حالت ویرایش روی ردیف انتخاب شده
  const handleEdit = () => {
    if (selectedRowId){
       setEditMode(true);
       setActiveRowId(false);
    }
  };

  // حذف ردیف
  const handleDelete = () => {
    if (!selectedRowId) return;
    sendDelete(selectedRowId);
    setRows(rows.filter(r => r.id !== selectedRowId));
    setSelectedRowId(null);
    setEditMode(false);
  };

  // ذخیره (نمونه)
  const handleSave = () => {
    if (!selectedRowId)       return;

    
    if (localStorage.getItem('Reserv_Id')===0)
    {
          alert('No room selected.')
      return;
    }
   
    if (addoredit)
    {
    
let y=rows.filter(r => r.id === selectedRowId)
       //  console.log("Saved rows:", y[0].Resturant_Desc);
      //    var dat =y[0].Resturant_Date
      //  var mon=Number(dat.getMonth() )+ 1 
      //    let indate = dat.getFullYear() + '-' + mon+ '-' + dat.getDate();
    setResturant_Date(y[0].Resturant_Date)
    setResturant_Desc(y[0].Resturant_Desc)
    setResturant_Pay(y[0].Resturant_Pay)
    setId(0);
    sendAdd(y);
    }
    else{
      let y=rows.filter(r => r.id === selectedRowId)
       //  console.log("Saved rows:", y[0].Resturant_Desc);
      //    var dat =y[0].Resturant_Date
      //  var mon=Number(dat.getMonth() )+ 1 
      //    let indate = dat.getFullYear() + '-' + mon+ '-' + dat.getDate();
    setResturant_Date(y[0].Resturant_Date)
    setResturant_Desc(y[0].Resturant_Desc)
    setResturant_Pay(y[0].Resturant_Pay)
    setId(y[0].Id);
    sendUpdate(y);
    }
 //   console.log("Saved rows:", rows);
    setEditMode(false);
    alert("Saved successfully!");
  };

  // باز کردن Popover تقویم
  const openCalendar = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(rowId);
  };

  // بروزرسانی مقدار یک ردیف
  const updateRow = (id, field, value) => {
    // console.log('id=',id)
    // console.log('field=',field)
    // console.log('value=',value)
    if (field ==='Resturant_Date')
   { var dat =value
    var mon=Number(dat.getMonth() )+ 1 
      let indate = dat.getFullYear() + '-' + mon+ '-' + dat.getDate();
      setRows(prev =>
        prev.map(r => (r.id === id ? { ...r, [field]: indate } : r))
      );
   }
   else
    setRows(prev =>
      prev.map(r => (r.id === id ? { ...r, [field]: value } : r))

    );
  };


  return (
    <>
        <div className="CheckIn"   style={{float:'left',width:'250px',height:'500px',display:'flex',marginLeft:'10px'}}>
    <Paper sx={{ height: 450, width: '100%' }}>
    <DataGrid onRowClick={handleRowClick} 
      rows={dataroom}
      columns={columns}
      getRowId={() => crypto.randomUUID()}
      rowHeight={32} // 👈 ارتفاع ردیف‌ها (پیش‌فرض 52 است)
      headerHeight={36} // 👈 ارتفاع هدرها هم می‌تونی کمتر کنی
      // initialState={{ pagination: { paginationModel } }}
      // pageSizeOptions={[5, 10]}
    //  checkboxSelection
      sx={{ border: 0 ,fontFamily:'Roboto' , fontWeight:'normal' , fontSize: '12px',backgroundColor:'#F2F2F2'}}
     // onSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
    
    />
      </Paper>
</div>

    <div style={{ display: "flex", gap: "10px" }}>
      {/* Toolbar عمودی */}
      <Stack spacing={1} direction="column">
        <IconButton color="primary" onClick={handleAdd}><AddIcon /></IconButton>
        <IconButton color="secondary" onClick={handleEdit} disabled={!selectedRowId}><EditIcon /></IconButton>
        <IconButton color="error" onClick={handleDelete} disabled={!selectedRowId}><DeleteIcon /></IconButton>
        <IconButton color="success" onClick={handleSave} disabled={!editMode}><SaveIcon /></IconButton>
      </Stack>

      {/* جدول */}
      <TableContainer component={Paper} sx={{ flex: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white' ,width:80}}>Date</TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white' }}>Pick Date</TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white' }}>Description</TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white' }}>Price</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

  {rows.map(row => (
          
    <TableRow
      key={row.id}
      selected={row.id === selectedRowId}
     onClick={() => setSelectedRowId(row.id)}
      sx={{ height: 36}} // ارتفاع سطر
      
    >
    
      <TableCell sx={{ padding: '4px 8px' }}>
      {/* {row.Resturant_Date ? row.Resturant_Date.toLocaleDateString("en-GB") : ""} */}
        {row.Resturant_Date }
  
      </TableCell>
      <TableCell sx={{ padding: '4px 8px'}}>
        <IconButton
          color="primary"
          size="small"
          onClick={(e) => openCalendar(e, row.id)}
        >
          <CalendarMonthIcon fontSize="small" />

        </IconButton>
      </TableCell>
      <TableCell sx={{ padding: '4px 8px' }}>
        <TextField
          value={row.Resturant_Desc}
          onChange={(e) => updateRow(row.id, "Resturant_Desc", e.target.value)}
          variant="standard"
          size="small"
          margin="dense"
          fullWidth
          disabled={!(editMode && selectedRowId === row.id)}
        />
      </TableCell>
      <TableCell sx={{ padding: '4px 8px' }}>
        <TextField
          type="text"
          value={row.Resturant_Pay}
          onChange={(e) => updateRow(row.id, "Resturant_Pay", Number(e.target.value))}
          variant="standard"
          size="small"
          margin="dense"
          fullWidth
          disabled={!(editMode && selectedRowId === row.id)}
        />
      </TableCell>
    </TableRow>
  ))}
</TableBody>

        </Table>
      </TableContainer>

      {/* Popover تقویم */}
      <Popover
        open={Boolean(anchorEl) && activeRowId !== null}
        anchorEl={anchorEl}
        onClose={() => { setAnchorEl(null); setActiveRowId(null); }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ sx: { p: 0, borderRadius: 2, overflow: "visible" } }}
      >
        <Calendar
          value={activeRowId ? rows.find(r => r.id === activeRowId)?.Resturant_Date || null : null}
       //   calendar={gregorian}
          onChange={(date) => {
            if (!activeRowId) return;
            const jsDate = date?.toDate?.() || date;
            updateRow(activeRowId, "Resturant_Date", jsDate);
            setAnchorEl(null);
                 setActiveRowId(null);
          }}
        />
      </Popover>
    </div>
    </>

  );
}
